<template>
  <div class="appbox" id="appBoxPage">
    <div class="topBox" id="topContent">
      <div class="top_icon">
        <div class="flex_box">
          <img class="logo" :src="icon" alt="" />
          <span class="title">{{ title }}</span>
        </div>
        <div class="flex_box">
          <div class="collet_title recommondBAck" @click="saveDesk"><span class="text_collect">点击收藏不迷路</span></div>
          <img class="logo_collect" @click="saveDesk" src="@/assets/icon_collect.png" alt="" />
          <!-- <div class="collet_title" v-if="isIstallPwa&&!isIOS()">已收藏</div>
          <img class="logo_collect" v-if="isIstallPwa&&!isIOS()" src="@/assets/icon_select.png" alt="" /> -->
        </div>
      </div>
      <!-- <div class="download" v-if="appType != 'saas'">
        <div class="leftBox">
          <cjimg :src="_getImgUrl(downloadInfo.logoUrl)" class="img_logo" alt="" />
          <div class="word_des">
            <div class="name">{{ downloadInfo.appName }}</div>
            <div class="des">{{ downloadInfo.appDesc }}</div>
          </div>
        </div>
        <div class="rightBox">
          <div class="btn" @click="handleDownload">下载应用</div>
        </div>
      </div> -->
      <div id="zb-nav-management-carousel" class="carousel-container">
        <van-swipe class="carousel" :autoplay="5000" indicator-color="white" :show-indicators="true">
          <van-swipe-item v-for="(v, index) in adData" @click="openUrl(v.link)" :key="index" class="swipe_item">
            <cjImg :src="_getImgUrl(v.image)" class="imgBox" alt="" />
            <span class="advTag" v-if="v.source == 1">广告</span>
          </van-swipe-item>
        </van-swipe>
      </div>

      <div class="content_box">
        <van-tabs v-model="active" :swipe-threshold="3" @click="onClick" @rendered="renderedItem" color="#ffffff" title-active-color="#ffffff" title-inactive-color="#CCCCCC" background="#161616">
          <van-tab v-for="(item, index) in appList" :title="item.name" :key="`${item.id}`">
            <div class="containerBox">
              <div class="topTitle">
                <div class="left_box">
                  <cjImg :src="_getImgUrl(item.icon)" class="appImg" alt="" />
                  <span class="name">{{ item.name }}</span>
                </div>
                <div class="download" @click="dowbloadApp(item)"><span>立即下载</span><img class="btn_img" src="@/assets/icon_down.png" /></div>
              </div>
              <div class="contentApp">
                <!-- 三列 -->
                <normalThree v-if="item.resourceTemplateCode == 'source' && item.resourceArr != 'nodata'" :resourceConfig="item.resourceConfig" :source="item.resourceArr" :_getImgUrl="_getImgUrl" />
                <!-- 两列 -->
                <normalTwo v-if="item.resourceTemplateCode == 'other' && item.resourceArr != 'nodata'" :source="item.resourceArr" :_getImgUrl="_getImgUrl" />
                <!-- 瀑布 -->
                <waterfullVue v-if="item.resourceTemplateCode == 'Belle' && item.resourceArr != 'nodata'" :source="item.resourceArr" :_getImgUrl="_getImgUrl" />
                <!-- 电影 -->
                <movieTypeVue v-if="item.resourceTemplateCode == 'video' && item.resourceArr != 'nodata'" :source="item.resourceArr" :_getImgUrl="_getImgUrl" />
                <waterHotVue v-if="item.resourceTemplateCode == 'live' && item.resourceArr != 'nodata'" :source="item.resourceArr" :_getImgUrl="_getImgUrl" />
                <div v-if="item.resourceArr == 'nodata' || !item.resourceTemplateId">暂无数据</div>
              </div>
            </div>
          </van-tab>
        </van-tabs>
        <div class="allClass" @click="showAllApp">
          <span>{{ show ? '收起' : '全部' }}</span>
          <van-icon :name="show ? 'arrow-up' : 'arrow-down'" />
        </div>
      </div>
    </div>
    <van-popup :get-container="getContainer" v-model="show" :overlay="false" position="right" :style="{ height: '100%', width: '100%', background: '#161616' }">
      <van-list
        v-if="appList.length > 0"
        v-model="loading"
        :style="{ overflow: 'auto', height: '100%' }"
        :finished="finished"
        finished-text="没有更多了"
        :offset="10"
        :immediate-check="true"
        @load="getApp"
      >
        <div class="app_box">
          <div class="app_item" v-for="(item, index) in appList" @click="chooseItem(item, index)" :key="`sss${item.id}`">
            <cjImg class="app_img" :src="_getImgUrl(item.icon)" />
            <div class="app_name">{{ item.name }}</div>
          </div>
        </div>
      </van-list>
    </van-popup>
  </div>
</template>

<script>
import '@/assets/style/guide.scss'
import { getChannelCode } from '@/utils/tools'
import { Toast } from 'vant'
// @ is an alias to /src
import normalThree from './components/normalThree.vue'
import normalTwo from './components/normalTwo.vue'
import HelloWorld from '@/components/HelloWorld.vue'
import { getAdd, getUploadConfig, getApp, getAppResource, downloadCount, verifyChannel } from '@/api/guide'
import { getImgUrl } from '@/utils/tools'
import waterfullVue from './components/waterfull.vue'
import movieTypeVue from './components/movieType.vue'
import waterHotVue from './components/waterHot.vue'
import { getAppdata, requestAppResource, requestAdData, requestTempalteConfig,requestImageConfig } from '@/utils/data'
export default {
  name: 'HomeView',
  components: {
    HelloWorld,
    normalThree,
    normalTwo,
    waterfullVue,
    movieTypeVue,
    waterHotVue
  },
  data() {
    return {
      showNoData: false,
      adData: [],
      uploadConfig: {},
      active: 0,
      show: false,
      appList: [],
      finished: false,
      loading: false,
      pageIndex: 1,
      channelCode: '',
      isIstallPwa: false,
      title: '轻梦导航',
      icon: require('@/assets/logo.jpg'),
      backGroundColor: '#0FB5FF'
    }
  },
  async created() {
    await this.getUploadConfig()
    if (process.env.VUE_APP_TITLE) {
      this.title = process.env.VUE_APP_TITLE
    }
    if (process.env.VUE_APP_ICON) {
      if (process.env.VUE_APP_IMGENCRYPT) {
        let imgResult = await window.fetchAndDec(process.env.VUE_APP_ICON).catch((err) => {})
        if (imgResult) {
          this.icon = 'data:image/jpg;base64,' + imgResult
        }
      } else {
        this.icon = process.env.VUE_APP_ICON
      }
    }
    if (process.env.VUE_APP_COLOR) {
      this.backGroundColor = process.env.VUE_APP_COLOR
    }
    setTimeout(() => {
      if (!window.deferredPrompt) {
        // 已经安装了pwa标签
        this.isIstallPwa = true
      }
      console.log(window.deferredPrompt, 'window.deferredPrompt')
    }, 1000)

    await this.verifyChannel()

    const params = {
      data: {
        state: 1,
        channelCode: this.channelCode
      },
      fetchAll: true,
      pageIndex: 1,
      pageSize: -1
    }
    requestAdData().then((res) => {
      this.adData = res
      console.log(res, 'resresresre')
    })
    this.getApp()
  },
  mounted() {
    const container = document.getElementById('appBoxPage') // 获取父容器
    const targetElement = container.getElementsByClassName('van-tabs__nav') // 取第一个匹配元素
    targetElement[0].addEventListener('scroll', this.handleScroll, true)
  },
  methods: {
    async verifyChannel() {
      // 渠道包验证 渠道包不对使用默认数据
      await verifyChannel({ data: getChannelCode() }).then((res) => {
        if (res.data) {
          this.channelCode = getChannelCode()
        } else {
          this.channelCode = process.env.VUE_APP_CODE
        }
      }).catch(err=>{})
    },
    openUrl(link) {
      if (!link) {
        return
      }
      const regx = /^(http(s?)|tmast|appmarket|vivoMarket|mimarket|anzhimarket|mstore|samsungapps):\/\//gi
      if (!link.match(regx)) {
        // window.open(`https://${adObj.link}`, adObj.name)
        Toast.fail('访问地址异常')
      } else {
        let a = document.createElement('a')
        a.style = 'display: none' // 创建一个隐藏的a标签
        a.download = ''
        a.href = link
        document.body.appendChild(a)
        a.click() // 触发a标签的click事件
        document.body.removeChild(a)
        // window.open(link)
      }
    },
    // 判断有限访问地址
    getDownLoadType(item) {
      let typeArr = item.type.split(',')
      const regx = /^(http(s?)|tmast|appmarket|vivoMarket|mimarket|anzhimarket|mstore|samsungapps):\/\//gi
      if (typeArr.indexOf('app') != -1 && item.appUrl.match(regx)) {
        return {
          ...item,
          downloadUrl: item.appUrl,
          type: 'app',
          des: '立即下载'
        }
      }
      if (typeArr.indexOf('h5') != -1 && item.h5Url.match(regx)) {
        return {
          ...item,
          downloadUrl: item.h5Url,
          type: 'app',
          des: '立即访问'
        }
      }
      if (typeArr.indexOf('applet') != -1 && item.appletUrl.match(regx)) {
        return {
          ...item,
          downloadUrl: item.appletUrl,
          type: 'applet',
          des: '立即下载'
        }
      }
      return {
        ...item,
        des: '立即访问'
      }
    },
    dowbloadApp(info) {
      let obj = this.getDownLoadType(info)
      if (!obj.downloadUrl) {
        return Taro.showToast({
          title: '访问地址异常',
          icon: 'none',
          duration: 1000,
          mask: true
        })
      }

      // console.log('toDownloadPage:', obj, process.env, process.env.NODE_ENV)
      let channel = this.channelCode
      const params = {
        data: {
          appId: obj.id,
          labelId: obj.labelId,
          channel
        }
      }
      downloadCount(params)
      console.log(obj.downloadUrl, 'downloadUrl')
      this.openUrl(obj.downloadUrl)
    },
    // _________下载方法分割
    getContainer() {
      // 方法 1：分步获取（推荐）
      const container = document.getElementById('appBoxPage') // 获取父容器
      const targetElement = container.getElementsByClassName('van-tabs__content') // 取第一个匹配元素
      console.log(targetElement[0], 'targetElementtargetElement')
      return targetElement[0]
    },
    // renderedItem(index) {
    //   let appItem = this.appList[index]
    //   if (!appItem.resourceTemplateId) {
    //     return
    //   }
    //   let params = {
    //     data: {
    //       appId: appItem.id,
    //       resourceTemplateId: appItem.resourceTemplateId,
    //       channelCode: this.channelCode
    //     },
    //     fetchAll: false,
    //     pageIndex: 1,
    //     pageSize: 10
    //   }
    //   getAppResource(params).then((res) => {
    //     if (res.code === '0000') {
    //       let resourceArr = res.data.map((item) => {
    //         return JSON.parse(item.resource)
    //       })
    //       if (resourceArr.length > 0) {
    //         this.$set(this.appList[index], 'resourceConfig', res.data[0].params)
    //         this.$set(this.appList[index], 'resourceArr', resourceArr)
    //       } else {
    //         this.$set(this.appList[index], 'resourceArr', 'nodata')
    //       }
    //     }
    //   })
    // },
    renderedItem(index) {
      let appItem = this.appList[index]
      requestAppResource(appItem.id).then((res) => {
        console.log(res, 'result22')
        // if (res.code === '0000') {
        let resourceArr = res.map((item) => {
          return JSON.parse(item.resource)
        })

        if (resourceArr.length > 0) {
          this.$set(this.appList[index], 'resourceArr', resourceArr)
        } else {
          this.$set(this.appList[index], 'resourceArr', 'nodata')
        }
        requestTempalteConfig(appItem.resourceTemplateId).then((result) => {
          this.$set(this.appList[index], 'resourceConfig', result)
          console.log(result, 'resulttem')
        })
      })
    },
    getUploadConfig() {
      requestImageConfig().then(res=>{
         this.uploadConfig = res
      }).catch(err=>{})
      // getUploadConfig({ data: {} }).then((res) => {
      //   if (res.code === '0000') {
      //     this.uploadConfig = res.data
      //   }
      // }).catch(err=>{})
    },
    _getImgUrl(_url) {
      const imgUrl = _url
      const { bucketMap, fileDomain } = this.uploadConfig
      return getImgUrl(imgUrl, bucketMap, fileDomain)
    },
    showAllApp() {
      this.show = !this.show
    },
    // getApp() {
    //   this.loading = true
    //   const params = {
    //     data: {
    //       // labelId: labelId,
    //       state: 1,
    //       channelCode: this.channelCode,
    //       existTemplate:true
    //     },
    //     fetchAll: true,
    //     pageIndex: this.pageIndex,
    //     pageSize: -1 // 不分页 -1
    //   }
    //   getApp(params)
    //     .then((res) => {
    //       this.pageIndex += 1
    //       this.appList.push(...res.data)
    //       this.finished = true
    //       this.loading = false
    //     })
    //     .catch((err) => {
    //       this.finished = true
    //       this.loading = false
    //     })
    // },
     async getApp() {
      this.appList = await getAppdata()
      this.active = this.appList[0]
      // this.renderedItem(this.appList[0], 0)
      this.finished = true
      this.loading = false
    },
    onClick() {
      this.show = false
    },
    handleScroll(e) {
      console.log('滚动事件触发', e.target, e.target.getBoundingClientRect())
    },
    saveDesk() {
      console.log(!this.isIOS(), 'this.isIOS()')
      if (!this.isIOS()) {
        console.log('处处进来了吗11231212')
        window.deferredPrompt.prompt()
        // Wait for the user to respond to the prompt
        window.deferredPrompt.userChoice.then((choiceResult) => {
          if (choiceResult.outcome === 'accepted') {
            console.log('User accepted the A2HS prompt')
            this.isIstallPwa = true
          } else {
            console.log('User dismissed the A2HS prompt')
          }
          window.deferredPrompt = null
        })
      } else {
        console.log('处处进来了吗')
        const node_iframe_el = document.getElementById('id-iframe-add-screen')
        if (node_iframe_el) {
          node_iframe_el.setAttribute('style', 'display:flex;height:100%;z-index:1001')
        } else {
          const myElement = document.createElement('iframe')
          myElement.id = 'id-iframe-add-screen'
          myElement.className = 'node-add-iframe'
          myElement.setAttribute('style', 'z-index:1001')
          myElement.src = '/static/guide/add.html'
          document.body.append(myElement)
        }
        const that = this
        const listener = function (event) {
          if (event.data) {
            const { from, name } = event.data || {}
            if (from === 'nodeAdd' && name === 'close') {
              that.clickNodeAddClose()
              window.removeEventListener('message', listener)
            }
          }
        }
        window.addEventListener('message', listener)
      }
    },
    isIOS() {
      return /iPhone|iPad|iPod/i.test(navigator.userAgent)
    },
    clickNodeAddClose() {
      const node_iframe_el = document.getElementById('id-iframe-add-screen')
      node_iframe_el && node_iframe_el.setAttribute('style', 'display:none')
    },
    chooseItem(item, index) {
      this.active = index
      this.show = false
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep .van-tabs__nav--line.van-tabs__nav--complete {
  padding-right: 70px;
}
.van-tabs {
  background: #161616;
  border-radius: 16px 16px 0px 0px;
  height: 100%;
}
::v-deep .van-tabs--line .van-tabs__wrap {
  border-radius: 16px 16px 0px 0px;
  // background: #161616;
}
::v-deep .van-tabs__nav--line.van-tabs__nav--complete {
  // background: #161616;
}
::v-deep .van-tab__text {
  font-family: PingFangSC-Medium;
  font-size: 14px;
  letter-spacing: -0px;
  text-align: center;
  font-weight: 500;
}
::v-deep .van-tabs__content {
  height: calc(100% - 44px);
  transform: translate(0);
}
::v-deep .van-tab__pane {
  height: 100%;
}
.appbox {
  .top_icon {
    background: #161616;
    .flex_box {
      display: flex;
      align-items: center;
    }
    display: flex;
    padding: 12px 14px;
    height: 20px;
    justify-content: space-between;
    position: sticky;
    z-index: 999;
    top: 0;
    .logo {
      width: 20px;
      height: 20px;
      margin-right: 4px;
    }
    .title {
      font-family: PingFangSC-Medium;
      font-size: 14px;
      color: #ffffff;
      letter-spacing: -0px;
      text-align: center;
      font-weight: 500;
    }
    .collet_title {
      font-family: PingFangSC-Medium;
      font-size: 12px;
      color: #cccccc;
      letter-spacing: -0px;
      text-align: right;
      font-weight: 500;
      display: flex;
      align-items: center;
      margin-right: 2px;
    }
    .recommondBAck {
      margin-right: 5px;
      background-image: url('../../assets/bubble.png');
      background-size: 100% 100%;
      display: flex;
      align-items: center;
      padding: 5px 10px;
      .text_collect {
        margin-right: 3px;
      }
    }
    .logo_collect {
      width: 20px;
      height: 20px;
    }
  }
}
.test {
  font-size: 20px;
}
.topBox {
  overflow: scroll;
  height: 100%;
  position: relative;
  .content_box {
    height: calc(100% - 35px);
    margin-top: -20px;
    overflow: hidden;
    position: relative;
    .containerBox {
      height: 100%;
      padding: 10px 14px;
      .contentApp {
        height: calc(100% - 50px);
        overflow: scroll;
      }
      .topTitle {
        display: flex;
        width: 100%;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 10px;
        .left_box {
          display: flex;
          .appImg {
            width: 24px;
            height: 24px;
            border-radius: 6px;
          }
          .name {
            font-family: PingFangSC-Medium;
            font-size: 17px;
            color: #ffffff;
            letter-spacing: -0px;
            font-weight: 500;
            margin-left: 5px;
          }
        }
        .download {
          background: v-bind(backGroundColor);
          border-radius: 12px;
          height: 24px;
          width: 78px;
          line-height: 24px;
          text-align: center;
          font-family: PingFangSC-Medium;
          font-size: 11px;
          color: #ffffff;
          letter-spacing: -0px;
          text-align: center;
          font-weight: 500;
          display: flex;
          align-items: center;
          justify-content: center;
          .btn_img {
            width: 16px;
            height: 16px;
            display: block;
            margin-left: 4px;
          }
        }
      }
    }
    .allClass {
      padding: 0 14px;
      height: 44px;
      display: flex;
      align-items: center;
      position: absolute;
      top: 0px;
      right: 0px;
      font-family: PingFangSC-Regular;
      font-size: 14px;
      color: #cccccc;
      letter-spacing: -0px;
      text-align: center;
      font-weight: 400;
      border-radius: 0px 10px 0 0;
      background-image: linear-gradient(90deg, rgba(22, 22, 22, 0.6) 0, rgba(22, 22, 22, 0.93) 30%, rgba(22, 22, 22, 1) 100%);
    }
  }
}
::v-deep .van-swipe__indicator--active {
  width: 12px !important;
  height: 6px !important;
  border-radius: 3px !important;
}
.carousel-container {
  //   height: 196.5px;
  // padding: 10px 14px;
  height: 202.5px;
  .carousel {
    width: 100%;
    height: 100%;
    .van-swipe__track {
      width: 100%;
    }
    .advTag {
      position: absolute;
      bottom: 22px;
      right: 3px;
      color: #1f1f1f;
      padding: 2px 8px;
      background: #dde3e9;
      font-size: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 10px;
      opacity: 0.5;
    }
  }
  .imgBox {
    // border-radius: 12px;
    width: 100%;
    // height: 100%;
    height: 202.5px;
    object-fit: cover;
  }
}
::v-deep .van-swipe__indicators {
  bottom: 25px;
}
.app_box {
  display: flex;
  flex-wrap: wrap;
  width: calc(100% - 28px);
  gap: 6px;
  padding: 0px 14px;
  .app_item {
    width: 82px;
    height: 84px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    background: rgba(255, 255, 255, 0.1);
    border-radius: 8px;
    .app_name {
      width: 100%;
      font-family: PingFangSC-Regular;
      letter-spacing: -0px;
      text-align: center;
      font-weight: 400;
      margin-top: 6px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      font-size: 11px;
      color: #cccccc;
    }
    .app_img {
      width: 44px;
      height: 44px;
    }
  }
}
</style>
